/**
 * CRITICAL: React initialization must happen FIRST
 * This file ensures React is fully loaded before any other module
 */

// Force React to load synchronously
import React from 'react';
import ReactDOM from 'react-dom';

// Ensure React is available globally before any other module loads
if (typeof window !== 'undefined') {
  (window as any).__REACT__ = React;
  (window as any).__REACT_DOM__ = ReactDOM;
  
  // Initialize React DevTools hook
  (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__ = (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__ || {
    supportsFiber: true,
    inject: () => {},
    onCommitFiberRoot: () => {},
    onCommitFiberUnmount: () => {},
  };
}

// Export for use in other modules
export { React, ReactDOM };
